// eslint-disable-next-line import/prefer-default-export
export const invertedMessages = {
  // Reassign messages
  'Don’t show this message again': 'CERTS_DONT_SHOW_LABEL',
  'Reassignment Can’t Be Undone': 'REASSIGN_UNDONE',
  Reassign: 'CERTS_REASSIGN',
  Cancel: 'CERTS_CANCEL',
  Submit: 'CERTS_SUBMIT',
  User: 'User_LABEL.ATTESTATIONS',
  Account: 'Account_LABEL.ATTESTATIONS',
  Role: 'Role_LABEL.ATTESTATIONS',
  Entitlement: 'Ent_LABEL.ATTESTATIONS',
  'Child Entitlement': 'Ent2_LABEL.ATTESTATIONS',
  'Assign the {lineItem} and their associated items to another certifier, and provide a reason. Any approvals or rejections will be cleared upon reassignment.':
    'CERTS_REASSIGN_SUBTITLE_USER',
  'Assign the {lineItem} to another certifier and provide a reason. Any approvals or rejections will be cleared upon reassignment.':
    'CERTS_REASSIGN_SUBTITLE',
  'When you reassign one of your certification items to another certifier, it’ll be removed from your list and can’t be retracted. Do you want to reassign this item?':
    'REASSIGN_WARNING_LABEL',
};
